/** Heights of the embedded maps on the location pages, in one place (#104). */
export const mapHeights = {
  overview: { phone: 'max(40dvh, 16rem)', compact: '50dvh', desktop: 'min(65dvh, 40rem)' },
  detail: { phone: 'max(35dvh, 14rem)', compact: '45dvh', desktop: 'min(55dvh, 32rem)' },
} as const;

export function mapHeight(
  page: keyof typeof mapHeights,
  viewport: { phone: boolean; compact: boolean },
): string {
  const heights = mapHeights[page];
  return viewport.phone ? heights.phone : viewport.compact ? heights.compact : heights.desktop;
}
